import * as React from 'react';
import injectSheet from 'react-jss';
import { Tabs, Button, Icon } from 'antd';
import { withRouter } from 'react-router';
import RFQEnquiryFF from './RFQEnquiryFF';
import RFQEnquiryShipper from './RFQEnquiryShipper';
import {
  bookingShipperRoute,
  getInquiryFFRoute,
  getInquiryShipperRoute,
  bookingFFRoute,
} from 'src/routing/utils';
import BookingList from './Booking/BookingList';
import { bookingPendingCount } from 'src/api/booking';
import { connect } from 'react-redux';
import withAuthAccessExim from 'src/components/hoc/withAuthAccessExim';
import { INQUIRY_FF, INQUIRY_SHIPPER } from 'src/utils/partsToShow/partsConstants';
import { MOBILE_BREAK_POINT } from 'src/globals';
import { sendEvent, EventCategories } from 'src/utils/gaService';
import { isValidArray } from 'src/Library/Helper';
import Navbar from 'src/components/navbar/Navbar';
import withAuth from 'src/components/hoc/withAuth';
import { tokens } from 'src/design-system';

const { TabPane } = Tabs;

const styles = (theme: any) => ({
  [`@media (max-width: ${MOBILE_BREAK_POINT}px)`]: {
    mainDiv: {
      display: 'inline-block',
    },
  },
  anchor: {
    fontSize: `${tokens.fontSize.body}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: theme.primaryColor,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: theme.primaryColor,
      textDecoration: 'none',
      cursor: 'pointer',
    },
    '&:active': {
      color: theme.primaryColor,
      textDecoration: 'none',
      cursor: 'pointer',
    },
    '&:visited': {
      color: theme.primaryColor,
      textDecoration: 'none',
      cursor: 'pointer',
    },
  },
  rightTools: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

class InquiryMain extends React.PureComponent<any, any> {
  state = {
    pendingBooking: false,
    isDiscoverPopUpVisible: false,
  };

  async componentDidMount() {
    const {
      location: { params, state: locationState },
      match,
    } = this.props;
    if (locationState?.rootTitle) {
      if (match.path.includes('ff')) {
        sendEvent(EventCategories.INQUIRY_BIDDING, 'Quote - Navbar');
      } else {
        sendEvent(EventCategories.INQUIRY_CREATION, 'Procure - Navbar');
      }
    }
    const response = await bookingPendingCount({ organisationType: this.props.viewType });
    if (response.isSuccess) {
      this.setState({
        pendingBooking: Number(response.data),
      });
    }
  }

  async componentWillReceiveProps() {
    const response = await bookingPendingCount({ organisationType: this.props.viewType });
    if (response.isSuccess) {
      this.setState({
        pendingBooking: Number(response.data),
      });
    }
  }

  handleTabChange = (key) => {
    const { history, ffModeList, shipperModeList, bookingModeList } = this.props;
    if (key === 'INQUIRY' && this.props.viewType === 'FF') {
      history.push(getInquiryFFRoute(isValidArray(ffModeList) ? `modeList=${ffModeList}` : ''));
    }
    if (key === 'INQUIRY' && this.props.viewType === 'SHIPPER') {
      history.push(
        getInquiryShipperRoute(isValidArray(shipperModeList) ? `modeList=${shipperModeList}` : '')
      );
    }
    if (key === 'BOOKING' && this.props.viewType === 'FF') {
      history.push(
        bookingFFRoute(isValidArray(bookingModeList) ? `modeList=${bookingModeList}` : '')
      );
    }
    if (key === 'BOOKING' && this.props.viewType === 'SHIPPER') {
      history.push(
        bookingShipperRoute(isValidArray(bookingModeList) ? `modeList=${bookingModeList}` : '')
      );
    }
  };

  renderDot = (style, char) => {
    return (
      <div
        style={{
          marginBottom: '3px',
          height: '8px',
          width: '8px',
          borderRadius: `${tokens.radius.lg}px`,
          verticalAlign: 'middle',
          background: 'red',
          ...style,
        }}
      >
        <span style={{ paddingRight: '2px' }}>{char}</span>
      </div>
    );
  };

  renderBooking = () => {
    const { pendingBooking } = this.state;
    return pendingBooking ? (
      <span style={{ display: 'flex' }}>{this.renderDot(null, null)}Booking</span>
    ) : (
      'Booking'
    );
  };

  tabsLayout = () => (
    <Tabs activeKey={this.props.tkey} onChange={this.handleTabChange} size="large">
      <TabPane tab="Inquiry" key="INQUIRY"></TabPane>
      <TabPane tab={this.renderBooking()} key="BOOKING"></TabPane>
    </Tabs>
  );

  render() {
    const { pendingBooking } = this.state;
    const { classes, showDiscoverBuyRates, showDiscoverSellRates } = this.props;
    const statusFilter =
      (this.props.location &&
        this.props.location.state &&
        this.props.location.state.statusFilter) ||
      false;
    const shouldKeepFilters =
      (this.props.location &&
        this.props.location.state &&
        this.props.location.state.shouldKeepFilters) ||
      false;
    const showDiscoverRates = showDiscoverSellRates || showDiscoverBuyRates;

    return (
      <div className={classes.mainDiv}>
        <Navbar
          random={this.state.pendingBooking}
          pageTitle={this.tabsLayout()}
          headerTitle={'Inquiry'}
          defaultNotificationTab={'INQUIRY'}
        />
        {this.props.tkey === 'INQUIRY' ? (
          this.props.viewType === 'FF' ? (
            <RFQEnquiryFF
              shouldResetFilters={!shouldKeepFilters}
              statusFilter={statusFilter}
            ></RFQEnquiryFF>
          ) : (
            <RFQEnquiryShipper
              statusFilter={statusFilter}
              shouldResetFilters={!shouldKeepFilters}
            ></RFQEnquiryShipper>
          )
        ) : this.props.tkey === 'BOOKING' ? (
          <BookingList {...this.props} />
        ) : null}
      </div>
    );
  }
}
const mapStateToProps = ({
  bookingInquiryReducer,
  masterData,
  inquiryFFReducer,
  inquiryShipperReducer,
}) => {
  return {
    bookingData: bookingInquiryReducer.bookingData,
    modules: masterData.modules,
    showDiscoverBuyRates: masterData.modules.show_discover_buy_rates,
    showDiscoverSellRates: masterData.modules.show_discover_sell_rates,
    ffModeList: inquiryFFReducer.appliedFilters?.modeList,
    shipperModeList: inquiryShipperReducer.appliedFilters?.modeList,
    bookingModeList: bookingInquiryReducer.appliedFilters?.modeList,
    orgType: masterData.userData.type,
  };
};

const InquiryMainStyled = injectSheet(styles)(InquiryMain);
export default withAuth(withRouter(
  connect(
    mapStateToProps,
    null
  )(withAuthAccessExim([INQUIRY_SHIPPER, INQUIRY_FF])(InquiryMainStyled)))
);
